import React, { Component } from 'react';
import * as oauthjs   from    '../auth/oauth';
import PropTypes from 'prop-types';


const styles = theme => ({
    root: {
      borderRadius: 0
    }
  });
  export default class RedirectChatCointainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: true,
            messageList: [],
            message:'',
            channelData:'',
            messageid:0
        };

    }

    componentDidMount(){

        let value = this.hash2Obj(window.location.hash);
        let newURL = location.protocol+'//'+window.location.host+'/chat/';
        console.log("location has is : " +JSON.stringify(value));
       if(value.access_token){
       this.createCookie('isAuth', '1', 7);
       window.location.replace(newURL);


       }


            }

  createCookie(name, value, days) {
                let cookie;
                let expires;
                let date = new Date();
                let baseDomain = this.getLocation().hostname.split('.').slice(-2).join('.');

                date.setTime(date.getTime() + ((days || 30) * 864e5));
                expires = date.toGMTString();
                cookie = encodeURIComponent(name) + '=' + value + ';expires=' + expires + ';path=/';
                if (baseDomain.indexOf('.') !== -1) {
                  cookie += ';domain=' + baseDomain;
                }
                window.document.cookie = cookie;
              }

        getLocation() {
                return window.location;
              }

        getLocationOrigin() {
                let loc = this.getLocation();

                return (loc.protocol) + "//" + (loc.hostname) + (loc.port ? (":" + (loc.port)) : '');
              }

    hash2Obj(hash) {
                if (hash) {
                  return hash
                    .slice(1)
                    .replace(/^\//, '')
                    .split(/[&?]/)
                    .map( function (el) { return el.split('='); } )
                    .reduce( function (pre, cur) {
                      let key = cur[0];
                      let val = cur[1];
                      pre[key] = val;
                      return pre;
                    }, {} );
                }
                return {};
              }
    render() {




        return (
            <div >


            </div>
        );
    }
}
